import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Tags.css';
import { NewsSideList } from '../../components/Widget';
import Link from '../../components/Link';

class Tags extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.object).isRequired,
    tag: PropTypes.string.isRequired,
    publication: PropTypes.string.isRequired,
    pageInfo: PropTypes.object.isRequired,
    currentPageIdx: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
  };

  renderNavigationBtns() {
    return (
      <div>
        {this.props.pageInfo.hasPreviousPage && (
          <Link
            className={s.pageControlBtn}
            reload
            to={`${this.props.tag}?page=${this.props.currentPageIdx - 1}`}
          >
            <i className="fa fa-arrow-left" />
            &nbsp;&nbsp;PREV {this.props.pageSize}
          </Link>
        )}
        {this.props.pageInfo.hasNextPage && (
          <Link
            className={s.pageControlBtn}
            reload
            to={`${this.props.tag}?page=${this.props.currentPageIdx + 1}`}
          >
            NEXT {this.props.pageSize}&nbsp;&nbsp;
            <i className="fa fa-arrow-right" />
          </Link>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className={`page-transitions ${s.root}`}>
        <div
          id="page-content"
          className={`page-content ${s.contentPageCustom}`}
        >
          <div className="content-strip half-bottom">
            <div className="above-overlay">
              <h1 className={`${s.sectionTitle}`}>
                <i className="fa fa-tags" /> {this.props.tag}
              </h1>
            </div>
          </div>
          <div className={s.allNewsSection}>
            {this.renderNavigationBtns()}
            <div>
              <NewsSideList
                items={this.props.news}
                baseRoute={`/publications/${this.props.publication}/news`}
                // Matches the breakpoints in Tags.css:
                //   <600px  = 1 col, image at ~30vw (row layout)
                //   600-899 = 2 cols, image fills card (~50vw - gap)
                //   900-1399 = 3 cols, image ~33vw
                //   ≥1400   = 4 cols, image ~25vw (capped by .root 1600px)
                imgSizes="(max-width: 599px) 30vw, (max-width: 899px) 48vw, (max-width: 1399px) 32vw, 380px"
              />
            </div>
            {this.renderNavigationBtns()}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Tags);
